import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Die Tabelle animals gibt es nicht mehr. Fälle liegen unter Meine Tiere. */
export default function TenantAnimalsRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
